// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"8":"bedb05fe","235":"c495c506","524":"a7b1018d","647":"2eb1fc0f","674":"a0b2773c","785":"d2caa118"}[chunkId] + ".css";
};